import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ProfileFormComponent } from '../../components/profile-form/profile-form.component';

@Component({
  selector: 'eng-profile-completion-modal',
  imports: [ProfileFormComponent],
  templateUrl: './profile-completion-modal.component.html',
  styleUrl: './profile-completion-modal.component.scss',
})
export class ProfileCompletionModalComponent {
  private readonly activeModal = inject(NgbActiveModal);

  onSuccess(): void {
    // Close modal after successful update
    this.activeModal.close('updated');
  }

  onSubmit(): void {
    // Handle submit event if needed
    // The form component handles the actual submission
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

  remindLater(): void {
    this.activeModal.dismiss('remind-later');
  }
}
